import { render, staticRenderFns } from "./ecnitem.vue?vue&type=template&id=c8fbbf7c&scoped=true&"
import script from "./ecnitem.vue?vue&type=script&lang=js&"
export * from "./ecnitem.vue?vue&type=script&lang=js&"
import style0 from "./ecnitem.vue?vue&type=style&index=0&id=c8fbbf7c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8fbbf7c",
  null
  
)

export default component.exports